import "./Startegy.scss";

import {
  Box,
  Breadcrumbs,
  Card,
  CardHeader,
  IconButton,
  Link,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";

import Actions from "../../organisms/Actions";
import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import BubbleClusterChart from "./TopicBubbleChart";
import Channels from "../../organisms/Channels";
import CustomToast from "../../utils/cutomToast/CustomToast";
import Loader from "../../utils/loader/Loader";
import TableWrapperWithPageHeader from "../../organisms/TableWrapperWithPageHeader";
import ViewListIcon from "@mui/icons-material/ViewList";
import axios from "axios";
import { channelDetailsColumns } from "../../utils/data";
import { urlConstants } from "../../components/constants/globalConstants";
import { useSelector } from "react-redux";

const Startegy = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    if (newValue === 0) {
      firstTime.current = true;
    } else if (newValue === 2) {
      fetchClusterData();
    } else if (newValue === 1) {
      fetchChannelAnalyizerData();
    }
  };
  const profileData = useSelector(
    (state: any) => state.businessDetails.profileDataByUniqueID
  );
  const [page, setPage] = useState(0);
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const firstTime = useRef(true);
  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };
  const toggleExpand = (index: number) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const [tab, setTab] = useState<string>("List"); // Only one tab active
  const [loading, setLoading] = useState(false);
  const [actionsData, setActionsData] = useState<any>([]);
  const [clustersData, setClustersData] = useState<any>([]);
  // const [editingIndex, setEditingIndex] = useState<number | null>(null);
  // const [editingField, setEditingField] = useState<string | null>(null);
  // const [searchProduct, setSearchProduct] = useState("");
  const [isChannelDetails, setIsChannelDetails] = useState(false);

  // Channel Details Table -- START
  const [detailsPage, setDetailsPage] = useState(0);
  const [detailsRowsPerPage, setDetailsRowsPerPage] = useState(10);

  const handleChangeDetailsPage = (event: unknown, newPage: number) => {
    setDetailsPage(newPage);
    // propHandleChangeDetailsPage?.(event, newPage);
  };
  const [cardData, setCardData] = useState<any>([]);
  const [filterCampaigns, setFilterCampaigns] = useState<any>([]);
  const [campaignTitle, setCampaignTitle] = useState<string>("");
  const [channelname, setChannelname] = useState<string>("");

  const handleChangeDetailsRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setDetailsRowsPerPage(newRowsPerPage);
    setDetailsPage(0);
    // propHandleChangeDetailsRowsPerPage?.(event);
  };
  // Channel Details Table -- END

  // Action Table -- START
  const [actionsRowsPerPage, setActionsRowsPerPage] = useState(10);
  const [actionsPage, setActionsPage] = useState(0);

  const handleChangeActionsRowsPerPage = (event: any) => {
    setActionsRowsPerPage(parseInt(event.target.value, 10));
    setActionsPage(0);
  };

  const handleChangeActionsPage = (event: any, newPage: number) => {
    setActionsPage(newPage);
  };

  useEffect(() => {
    if (firstTime.current) {
      fetchActionData();
      firstTime.current = false;
    }
  });
  // Action Table -- END
  // const [icpList, setIcpList] = useState([
  //   {
  //     name: "The Busy Entrepreneur",
  //     ageRange: "30-40",
  //     occupation: "Small business owner",
  //     keyMotivations: [
  //       "Growing her business while maintaining a balanced lifestyle",
  //     ],
  //     painPoints: [
  //       "Limited time to focus on marketing and customer acquisition",
  //       "Difficulty managing daily tasks and delegating effectively",
  //       "Struggles with finding reliable tools and services that save time",
  //     ],
  //     open: true,
  //   },
  //   {
  //     name: "The Hardwork Entrepreneur",
  //     ageRange: "30-40",
  //     occupation: "Small business owner",
  //     keyMotivations: [
  //       "Growing her business while maintaining a balanced lifestyle",
  //     ],
  //     painPoints: [
  //       "Limited time to focus on marketing and customer acquisition",
  //       "Difficulty managing daily tasks and delegating effectively",
  //       "Struggles with finding reliable tools and services that save time",
  //     ],
  //     open: true,
  //   },
  // ]);

  // const [productList, setProductList] = useState([
  //   {
  //     name: "Product #1",
  //     painPoint: "30",
  //     solution: "for business",
  //     useCase: "developing business",
  //     open: true,
  //   },
  //   {
  //     name: "Product #2",
  //     painPoint: "30",
  //     solution: "for business",
  //     useCase: "developing business",
  //     open: true,
  //   },
  //   {
  //     name: "Product #3",
  //     painPoint: "30",
  //     solution: "for business",
  //     useCase: "developing business",
  //     open: true,
  //   },
  // ]);

  // const fetchClusterData = async () => {
  //   try {
  //     setLoading(true);
  //     const fetchClusterConfig: IAPIConfig = {
  //       URL: `/WFTopic/GetTopics?businessId=${profileData.UniqueId}`,
  //       method: "GET",
  //     };
  //     const fetchedClusters: any = await doApi(fetchClusterConfig, "seedcore");
  //     if (fetchedClusters?.data.err === false) {
  //       if (fetchedClusters.data.data) {
  //         const finalObj = JSON.parse(fetchedClusters.data.data);
  //         const transformed = finalObj.map((topic: any) => ({
  //           topicName: topic.Name,
  //           clusters: topic.Clusters.map((cluster: any) => cluster.Name),
  //           keywords: topic.Clusters.flatMap(
  //             (cluster: any) =>
  //               cluster.Keywords?.map((kw: any) => kw.Name) || []
  //           ),
  //         }));
  //         setClustersData(transformed);
  //       } else {
  //         CustomToast(fetchedClusters.data.message, "error");
  //       }
  //     } else {
  //       CustomToast(fetchedClusters.data.message, "error");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching settings:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchClusterData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${urlConstants.PROMPT_URL}/client/create-topic-clusters?business_id=${profileData?.UniqueId}`
      );
      const finalRes = response.data;

      if (finalRes?.status === "success") {
        const filePathURL1 = finalRes?.output_data?.download_url;
        const filePathURL2 =
          finalRes?.metadata?.create_intent_cluster?.output_data?.download_url;

        const response1 = await axios.get(filePathURL1); // Topics with cluster array
        const response2 = await axios.get(filePathURL2); // Cluster details

        // Create a map for faster cluster lookup
        const clusterMap = new Map(
          response2.data.clusters.map((clusterItem: any) => [
            clusterItem.cluster,
            clusterItem,
          ])
        );

        // Flatten all topic-cluster matches
        const matchedData = response1.data.flatMap((topicItem: any) =>
          (topicItem.clusters || []).map((clusterName: string) => {
            const clusterDetails: any = clusterMap.get(clusterName);

            return {
              topicName: topicItem.topic,
              cluster: clusterName,
              total_search_volume: clusterDetails?.total_search_volume || 0,
              keywords: clusterDetails?.keywords || [],
            };
          })
        );

        setClustersData(matchedData);
      } else {
        CustomToast(
          finalRes?.detail ||
            finalRes?.detail[0]?.msg ||
            finalRes?.output_data?.errors?.[0] ||
            "NO DATA FOUND.",
          "error"
        );
        setClustersData([]);
      }
    } catch (err: any) {
      CustomToast(
        err?.response?.data?.detail?.[0]?.msg ||
          err?.response?.data?.detail ||
          "Server Error.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchChannelAnalyizerData = async () => {
    try {
      setLoading(true);
      let response = await axios.get(
        `${urlConstants.PROMPT_URL}/client/channel-analyzer?business_id=${profileData?.UniqueId}`
      );
      const finalRes: any = response.data;

      if (finalRes?.status === "success") {
        const filePathURL = finalRes?.output_data?.download_url;
        response = await axios.get(filePathURL);
        const finalResult = response.data.channels;
        const flat: any[] = [];

        if (finalResult && typeof finalResult === "object") {
          Object.values(finalResult).forEach((channel: any) => {
            const channelName = channel.channel_name;
            const channelRelevance = channel.channel_relevance;

            Object.values(channel.campaigns || {}).forEach((campaign: any) => {
              const campaignName = campaign.campaign_name;
              const campaignRelevance = campaign.campaign_relevance;

              campaign.clusters?.forEach((cluster: any) => {
                flat.push({
                  channelName,
                  channelRelevance,
                  campaignName,
                  campaignRelevance,
                  clusterName: cluster?.cluster_name,
                  contentType: cluster?.contentType,
                  description: cluster?.description,
                  title: cluster.title,
                  clusterRelevance: cluster.cluster_relevance,
                  clusterRelevanceLevel: cluster.cluster_relevance_level,
                  relatedKeywords: (cluster.related_keywords || []).join(", "),
                });
              });
            });
          });
        }
        setCardData(flat);
      } else {
        CustomToast(
          finalRes?.detail ||
            finalRes?.detail[0].msg ||
            finalRes?.output_data.errors[0] ||
            "NO DATA FOUND.",
          "error"
        );
        setCardData([]);
      }
    } catch (err: any) {
      CustomToast(
        err?.response?.data?.detail[0]?.msg ||
          err?.response?.data?.detail ||
          "Server Error.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchActionData = async () => {
    try {
      setLoading(true);
      let response = await axios.get(
        `${urlConstants.PROMPT_URL}/client/create-blog-page-plan?business_id=${profileData?.UniqueId}`
      );
      const finalRes = response.data;

      if (finalRes?.status === "success") {
        const filePathURL = finalRes?.output_data?.download_url;
        response = await axios.get(filePathURL);
        const finalPages = response?.data?.pages;
        const actionsRows = finalPages.map((item: any) => ({
          classification: item.classification,
          keyword: item.keyword,
          pageType: item.page_type,
          parentKW: item.parent_kw,
          searchIntent: item.search_intent,
          searchVolume: item.search_volume,
          relevanceScore: item.business_relevance_score,
        }));
        setActionsData(actionsRows);
      } else {
        CustomToast(
          finalRes?.detail ||
            finalRes?.detail[0].msg ||
            finalRes?.output_data.errors[0] ||
            "NO DATA FOUND.",
          "error"
        );
        setActionsData([]);
      }
    } catch (err: any) {
      CustomToast(
        err?.response?.data?.detail[0]?.msg ||
          err?.response?.data?.detail ||
          "Server Error.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleViewOrientation = (
    _event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      setTab(newValue);
    }
  };

  // const handleAddIcp = () => {
  //   setIcpList([
  //     ...icpList,
  //     {
  //       name: "",
  //       ageRange: "",
  //       occupation: "",
  //       keyMotivations: [""],
  //       painPoints: [""],
  //       open: true,
  //     },
  //   ]);
  // };

  // const handleDeleteIcp = (index: number) => {
  //   const updatedList = [...icpList];
  //   updatedList.splice(index, 1);
  //   setIcpList(updatedList);
  // };

  // const toggleCollapse = (index: number) => {
  //   const updatedList = icpList.map((item, idx) => ({
  //     ...item,
  //     open: idx === index ? !item.open : false,
  //   }));
  //   setIcpList(updatedList);
  // };

  // const toggleProductCollapse = (index: number) => {
  //   const updatedList = productList.map((item, idx) => ({
  //     ...item,
  //     open: idx === index ? !item.open : false,
  //   }));
  //   setProductList(updatedList);
  // };

  // const handleFieldChange = (index: number, field: string, value: string) => {
  //   const updated: any = [...icpList];
  //   updated[index][field] = value;
  //   setIcpList(updated);
  // };

  // const handleFieldProductChange = (
  //   index: number,
  //   field: string,
  //   value: string
  // ) => {
  //   const updated: any = [...productList];
  //   updated[index][field] = value;
  //   setProductList(updated);
  // };

  // const handleArrayFieldChange = (
  //   index: number,
  //   field: "keyMotivations" | "painPoints",
  //   itemIdx: number,
  //   value: string
  // ) => {
  //   const updated = [...icpList];
  //   updated[index][field][itemIdx] = value;
  //   setIcpList(updated);
  // };

  const [channelToggleOption, setChannelToggleOption] =
    React.useState<string>("all");

  const handleChannelToggleChange = (
    event: React.MouseEvent<HTMLElement>,
    opt: string | null
  ) => {
    if (opt !== null) {
      setChannelToggleOption(opt);
    }
  };

  function handleBreadcrumbClick(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) {
    setIsChannelDetails(false);
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  }

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="text.primary"
      href="/"
      fontWeight={500}
      fontSize={"14px"}
      onClick={handleBreadcrumbClick}
    >
      Channels
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="text.primary"
      fontWeight={500}
      fontSize={"14px"}
      href="/material-ui/getting-started/installation/"
      onClick={handleBreadcrumbClick}
    >
      {channelname}
    </Link>,
    <Typography
      key="3"
      sx={{ color: "#0F4343", fontWeight: 500, fontSize: "14px" }}
    >
      Campaign
    </Typography>,
  ];

  const handleCardClick = (title: string, channelName: string) => {
    const matchedCampaigns = cardData.filter(
      (val: any) => val.campaignName.toLowerCase() === title.toLowerCase()
    );

    if (matchedCampaigns.length > 0) {
      const resCampaigns = matchedCampaigns.map((c: any) => ({
        cluster: c.clusterName,
        contentType: c.contentType,
        title: c.title,
        description: c.description,
      }));

      setCampaignTitle(title);
      setChannelname(channelName);
      setFilterCampaigns(resCampaigns); // assuming this expects an array
    }

    setIsChannelDetails(true);
  };

  const [sortBy, setSortBy] = useState<"keywords" | "searchVolume" | null>(
    "keywords"
  );
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const handleSort = (column: "keywords" | "searchVolume") => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const sortedData = [...clustersData].sort((a, b) => {
    let aValue = 0;
    let bValue = 0;

    if (sortBy === "keywords") {
      aValue = a.keywords?.length || 0;
      bValue = b.keywords?.length || 0;
    } else if (sortBy === "searchVolume") {
      aValue = a.total_search_volume || 0;
      bValue = b.total_search_volume || 0;
    }

    if (sortOrder === "asc") return aValue - bValue;
    return bValue - aValue;
  });

  const paginatedData = sortedData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box className="startegy-container">
      <Box className="main-container">
        <Box className="pagination">
          <Box className="header-title">
            <Typography
              variant="h4"
              sx={{ textAlign: "center", color: "rgba(0, 0, 0, 0.87)" }}
            >
              Dashboard{" "}
              <span className="sub-header-title">| Hawaii Roasters</span>
            </Typography>
          </Box>

          <Box className="tabs-container">
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              className="tabs-container"
              variant="scrollable"
              TabIndicatorProps={{
                style: {
                  width: "125px",
                },
              }}
              scrollButtons="auto"
              sx={{ borderBottom: "1px solid #0000000F", flex: 1 }}
            >
              {[
                { key: "action-log", value: 0, label: "Actions" },
                { key: "channels", value: 1, label: "Channels" },
                // { key: "audience", value: 2, label: "Audience" },
                // { key: "positioning ", value: 3, label: "Positioning" },
                { key: "topics", value: 2, label: "Topics" },
              ].map((tab) => (
                <Tab
                  key={tab.key}
                  value={tab.value}
                  className={`tab ${tab.value === 0 ? "tab-fisttab" : "tab"}`}
                  label={
                    <Box className="tab-label">
                      <Typography className="tab-label-text">
                        {tab.label}
                      </Typography>
                    </Box>
                  }
                />
              ))}
            </Tabs>
            {tabIndex === 1 && (
              <Box>
                {isChannelDetails ? (
                  <Stack spacing={2}>
                    <Breadcrumbs separator="›" aria-label="breadcrumb">
                      {breadcrumbs}
                    </Breadcrumbs>
                  </Stack>
                ) : (
                  <ToggleButtonGroup
                    color="primary"
                    value={channelToggleOption}
                    exclusive
                    onChange={handleChannelToggleChange}
                    aria-label="Channel Filters"
                    sx={{
                      height: "38px",
                      color: "#0F4343",
                      fontWeight: "bold",
                      fontSize: "13px",
                      "& .MuiToggleButton-root": {
                        textTransform: "none",
                        width: "74px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    }}
                  >
                    <ToggleButton value="all">All</ToggleButton>
                    <ToggleButton value="high">High</ToggleButton>
                    <ToggleButton value="medium">Medium</ToggleButton>
                    <ToggleButton value="low">Low</ToggleButton>
                  </ToggleButtonGroup>
                )}
              </Box>
            )}
          </Box>
        </Box>
        <Loader spinning={loading}>
          {tabIndex === 0 && (
            <Actions
              actionsRows={actionsData}
              actionsRowsPerPage={actionsRowsPerPage}
              actionsPage={actionsPage}
              subtitle={`${actionsData.length} actions for review`}
              handleChangeActionsPage={handleChangeActionsPage}
              handleChangeActionsRowsPerPage={handleChangeActionsRowsPerPage}
            />
          )}
          {tabIndex === 1 && (
            <Box>
              {isChannelDetails ? (
                <TableWrapperWithPageHeader
                  title={campaignTitle}
                  subtitle={`${filterCampaigns.length} total clusters`}
                  columns={channelDetailsColumns}
                  rows={filterCampaigns}
                  rowsPerPage={detailsRowsPerPage}
                  page={detailsPage}
                  handleChangePage={handleChangeDetailsPage}
                  handleChangeRowsPerPage={handleChangeDetailsRowsPerPage}
                />
              ) : (
                <Channels
                  handleCardClick={handleCardClick}
                  cardData={cardData}
                  channelToggleOption={channelToggleOption}
                />
              )}
            </Box>
          )}
          {/* {tabIndex === 2 && (
            <>
              <Box className="audience-header">
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Add />}
                  onClick={handleAddIcp}
                >
                  Add ICP
                </Button>
              </Box>
              {icpList.map((icp, index) => (
                <Box className="audience-acc-container">
                  <Box className="inner-container">
                    <Table className="accordin-table">
                      <TableHead className="accordin-table-header">
                        <Box className="header-inner">
                          <Box className="header-text">
                            <Box className="text">
                              {editingIndex === index &&
                              editingField === "headerName" ? (
                                <TextField
                                  variant="standard"
                                  value={icp.name}
                                  fullWidth
                                  autoFocus
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                  inputProps={{
                                    style: {
                                      color: "#FFF",
                                      textAlign: "center",
                                    },
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: "#FFF",
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                  onDoubleClick={() => {
                                    setEditingIndex(index);
                                    setEditingField("headerName");
                                  }}
                                >
                                  {icp.name || "Untitled"}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <IconButton onClick={() => handleDeleteIcp(index)}>
                          <Delete sx={{ color: "#FFF" }} />
                        </IconButton>
                        <IconButton onClick={() => toggleCollapse(index)}>
                          {icp.open ? (
                            <ExpandLess sx={{ color: "#FFF" }} />
                          ) : (
                            <ExpandMore sx={{ color: "#FFF" }} />
                          )}
                        </IconButton>
                      </TableHead>
                      <Collapse in={icp.open} sx={{ width: "100%" }}>
                        <TableRow className="accordin-table-row">
                          <Box className="first-row">
                            <TableCell className="first-cell">
                              <Typography className="text">Name</Typography>
                            </TableCell>
                            <TableCell className="second-cell">
                              {editingIndex === index &&
                              editingField === "name" ? (
                                <TextField
                                  variant="filled"
                                  value={icp.name}
                                  fullWidth
                                  autoFocus
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant="body2"
                                  onDoubleClick={() => {
                                    setEditingIndex(index);
                                    setEditingField("name");
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {icp.name || "-"}
                                </Typography>
                              )}
                            </TableCell>
                          </Box>
                        </TableRow>
                        <TableRow className="accordin-table-row">
                          <Box className="first-row">
                            <TableCell className="first-cell">
                              <Typography className="text">
                                Age Range
                              </Typography>
                            </TableCell>
                            <TableCell className="second-cell">
                              {editingIndex === index &&
                              editingField === "ageRange" ? (
                                <TextField
                                  variant="standard"
                                  value={icp.ageRange}
                                  autoFocus
                                  fullWidth
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "ageRange",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant="body2"
                                  onDoubleClick={() => {
                                    setEditingIndex(index);
                                    setEditingField("ageRange");
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {icp.ageRange || "-"}
                                </Typography>
                              )}
                            </TableCell>
                          </Box>
                        </TableRow>
                        <TableRow className="accordin-table-row">
                          <Box className="first-row">
                            <TableCell className="first-cell">
                              <Typography className="text">
                                Occupation
                              </Typography>
                            </TableCell>
                            <TableCell className="second-cell">
                              {editingIndex === index &&
                              editingField === "occupation" ? (
                                <TextField
                                  variant="standard"
                                  value={icp.occupation}
                                  fullWidth
                                  autoFocus
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "occupation",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant="body2"
                                  onDoubleClick={() => {
                                    setEditingIndex(index);
                                    setEditingField("occupation");
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {icp.occupation || "-"}
                                </Typography>
                              )}
                            </TableCell>
                          </Box>
                        </TableRow>
                        <TableRow className="accordin-table-row">
                          <Box
                            className="first-row"
                            sx={{
                              height: `${
                                (icp.keyMotivations.length + 1) * 56
                              }px !important`,
                            }}
                          >
                            <TableCell className="first-cell">
                              <Typography className="text">
                                Key Motivations
                              </Typography>
                            </TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                flex: "1 0 0",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                height: `${
                                  (icp.keyMotivations.length + 1) * 56
                                }px !important`,
                              }}
                            >
                              {icp.keyMotivations?.map((motivation, idx) => (
                                <TableCell
                                  className="second-cell"
                                  sx={{ justifyContent: "space-between" }}
                                >
                                  {editingIndex === index &&
                                  editingField === `motivation-${idx}` ? (
                                    <TextField
                                      variant="standard"
                                      value={motivation}
                                      autoFocus
                                      fullWidth
                                      onChange={(e) =>
                                        handleArrayFieldChange(
                                          index,
                                          "keyMotivations",
                                          idx,
                                          e.target.value
                                        )
                                      }
                                      onBlur={() => setEditingField(null)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter")
                                          setEditingField(null);
                                      }}
                                    />
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      onDoubleClick={() => {
                                        setEditingIndex(index);
                                        setEditingField(`motivation-${idx}`);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {motivation || "-"}
                                    </Typography>
                                  )}

                                  <IconButton
                                    onClick={() => {
                                      const updatedList = [...icpList];
                                      updatedList[index].keyMotivations.splice(
                                        idx,
                                        1
                                      );
                                      setIcpList(updatedList);
                                    }}
                                    className="icon-button"
                                  >
                                    <RemoveCircleOutlineRounded
                                      style={{
                                        color: "#000000",
                                        opacity: "0.12",
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                              ))}

                              <TableCell className="second-cell-button">
                                <Button
                                  startIcon={<Add />}
                                  variant="text"
                                  size="medium"
                                  color="primary"
                                  onClick={() => {
                                    const updatedList = [...icpList];
                                    updatedList[index].keyMotivations.push("");
                                    setIcpList(updatedList);
                                  }}
                                >
                                  Add
                                </Button>
                              </TableCell>
                            </Box>
                          </Box>
                        </TableRow>
                        <TableRow className="accordin-table-row">
                          <Box
                            className="first-row"
                            sx={{
                              height: `${
                                (icp.painPoints.length + 1) * 56
                              }px !important`,
                            }}
                          >
                            <TableCell className="first-cell">
                              <Typography className="text">
                                Pain Points
                              </Typography>
                            </TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column ",
                                flex: "1 0 0",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                height: `${
                                  (icp.painPoints.length + 1) * 56
                                }px !important`,
                              }}
                            >
                              {icp.painPoints?.map((point, idx) => (
                                <TableCell
                                  className="second-cell"
                                  sx={{ justifyContent: "space-between" }}
                                >
                                  {editingIndex === index &&
                                  editingField === `pain-${idx}` ? (
                                    <TextField
                                      variant="standard"
                                      value={point}
                                      fullWidth
                                      autoFocus
                                      onChange={(e) =>
                                        handleArrayFieldChange(
                                          index,
                                          "painPoints",
                                          idx,
                                          e.target.value
                                        )
                                      }
                                      onBlur={() => setEditingField(null)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter")
                                          setEditingField(null);
                                      }}
                                    />
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      onDoubleClick={() => {
                                        setEditingIndex(index);
                                        setEditingField(`pain-${idx}`);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {point || "-"}
                                    </Typography>
                                  )}

                                  <IconButton
                                    onClick={() => {
                                      const updatedList = [...icpList];
                                      updatedList[index].painPoints.splice(
                                        idx,
                                        1
                                      );
                                      setIcpList(updatedList);
                                    }}
                                    className="icon-button"
                                  >
                                    <RemoveCircleOutlineRounded
                                      style={{
                                        color: "#000000",
                                        opacity: "0.12",
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                              ))}

                              <TableCell className="second-cell-button">
                                <Button
                                  startIcon={<Add />}
                                  variant="text"
                                  color="primary"
                                  size="medium"
                                  onClick={() => {
                                    const updatedList = [...icpList];
                                    updatedList[index].painPoints.push("");
                                    setIcpList(updatedList);
                                  }}
                                >
                                  Add
                                </Button>
                              </TableCell>
                            </Box>
                          </Box>
                        </TableRow>
                      </Collapse>
                    </Table>
                  </Box>
                </Box>
              ))}
            </>
          )} */}
          {/* {tabIndex === 3 && (
            <>
              <Box className="position-container">
                <TextField
                  id="search-prodcut"
                  label="Search"
                  value={searchProduct}
                  onChange={(e) => setSearchProduct(e.target.value)}
                  variant="outlined"
                  placeholder="Search product..."
                  size="small"
                  sx={{ width: 300 }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<Add />}
                >
                  Add Offering
                </Button>
              </Box>
              {productList.map((item, index) => (
                <Box className="position-acc-container">
                  <Box className="inner-container">
                    <Table className="accordin-table">
                      <TableHead className="accordin-table-header">
                        <Box className="header-inner">
                          <Box className="header-text">
                            <Box className="text">
                              {editingIndex === index &&
                              editingField === "headerName" ? (
                                <TextField
                                  variant="standard"
                                  value={item.name}
                                  fullWidth
                                  autoFocus
                                  onChange={(e) =>
                                    handleFieldProductChange(
                                      index,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                  inputProps={{
                                    style: {
                                      color: "#FFF",
                                      textAlign: "center",
                                    },
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: "#FFF",
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                  onDoubleClick={() => {
                                    setEditingIndex(index);
                                    setEditingField("headerName");
                                  }}
                                >
                                  {item.name || "Untitled"}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <IconButton
                          onClick={() => toggleProductCollapse(index)}
                        >
                          {item.open ? (
                            <ExpandLess sx={{ color: "#FFF" }} />
                          ) : (
                            <ExpandMore sx={{ color: "#FFF" }} />
                          )}
                        </IconButton>
                      </TableHead>
                      <Collapse in={item.open} sx={{ width: "100%" }}>
                        <TableRow className="accordin-table-row">
                          <Box className="first-row">
                            <TableCell className="product-header-cell">
                              <Typography className="text">
                                Pain Point
                              </Typography>
                            </TableCell>
                            <TableCell className="product-header-cell">
                              <Typography className="text">Solution</Typography>
                            </TableCell>
                            <TableCell className="product-header-cell">
                              <Typography className="text">Use Case</Typography>
                            </TableCell>
                          </Box>
                        </TableRow>
                        <TableRow className="accordin-table-row">
                          <Box className="first-row">
                            <TableCell className="product-inner-cell">
                              {editingIndex === index &&
                              editingField === "painPoint" ? (
                                <TextField
                                  variant="filled"
                                  value={item.name}
                                  fullWidth
                                  autoFocus
                                  onChange={(e) =>
                                    handleFieldProductChange(
                                      index,
                                      "painPoint",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant="body2"
                                  onDoubleClick={() => {
                                    setEditingIndex(index);
                                    setEditingField("painPoint");
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item.painPoint || "-"}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell className="product-inner-cell">
                              {editingIndex === index &&
                              editingField === "solution" ? (
                                <TextField
                                  variant="standard"
                                  value={item.solution}
                                  autoFocus
                                  fullWidth
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "solution",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                />
                              ) : (
                                <Typography
                                  variant="body2"
                                  onDoubleClick={() => {
                                    setEditingIndex(index);
                                    setEditingField("solution");
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item.solution || "-"}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell className="product-inner-cell">
                              {editingIndex === index &&
                              editingField === "useCase" ? (
                                <TextField
                                  variant="standard"
                                  value={item.useCase}
                                  autoFocus
                                  fullWidth
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "useCase",
                                      e.target.value
                                    )
                                  }
                                  onBlur={() => setEditingField(null)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      setEditingField(null);
                                  }}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    onDoubleClick={() => {
                                      setEditingIndex(index);
                                      setEditingField("useCase");
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {item.useCase || "-"}
                                  </Typography>
                                  <IconButton
                                    onClick={() => {
                                      const updatedList = [...productList];
                                      updatedList.splice(index, 1);
                                      setProductList(updatedList);
                                    }}
                                    className="icon-button"
                                  >
                                    <RemoveCircleOutlineRounded
                                      style={{
                                        color: "#000000",
                                        opacity: "0.12",
                                      }}
                                    />
                                  </IconButton>
                                </Box>
                              )}
                            </TableCell>
                          </Box>
                        </TableRow>
                      </Collapse>
                    </Table>
                  </Box>
                </Box>
              ))}
            </>
          )} */}
          {tabIndex === 2 && (
            <Card className="card-container">
              <CardHeader
                className="card-header"
                title={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box className="card-header-content">
                      <Typography
                        variant="h5"
                        sx={{
                          color: "rgba(0, 0, 0, 0.87) !important",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                        }}
                      >
                        Topics
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "rgba(0, 0, 0, 0.60) !important",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                        }}
                      >
                        {paginatedData.length} total topics
                      </Typography>
                    </Box>
                    <ToggleButtonGroup
                      value={tab}
                      className="toggleButtonGroup"
                      exclusive
                      onChange={handleViewOrientation}
                      sx={{ height: "40px", color: "#fff" }}
                    >
                      <ToggleButton
                        disableRipple
                        className="toggleButton"
                        value="List"
                      >
                        <ViewListIcon sx={{ marginRight: 1 }} />
                        <span className="toggle-text">List</span>
                      </ToggleButton>

                      <ToggleButton
                        disableRipple
                        className="toggleButton"
                        value="Maps"
                      >
                        <BubbleChartIcon sx={{ marginRight: 1 }} />
                        <span className="toggle-text">Maps</span>
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                }
              />
              {tab === "List" ? (
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>TOPIC NAME</TableCell>
                          <TableCell
                            onClick={() => handleSort("searchVolume")}
                            style={{ cursor: "pointer" }}
                          >
                            SEARCH VOLUME{" "}
                            {sortBy === "searchVolume" &&
                              (sortOrder === "desc" ? "↑" : "↓")}
                          </TableCell>
                          <TableCell>CLUSTER NAME</TableCell>
                          <TableCell
                            onClick={() => handleSort("keywords")}
                            style={{ cursor: "pointer" }}
                          >
                            KEYWORDS{" "}
                            {sortBy === "keywords" &&
                              (sortOrder === "desc" ? "↑" : "↓")}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paginatedData.length > 0 &&
                          paginatedData
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row: any, index: any) => {
                              // const isClusterExpand = expandedRow === index;
                              const isExpanded = expandedRow === index;

                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    sx={{
                                      padding: "10px !important",
                                      borderBottom:
                                        "1px solid rgba(0, 0, 0, 0.06) !important",
                                    }}
                                  >
                                    {row.topicName}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      padding: "10px !important",
                                      borderBottom:
                                        "1px solid rgba(0, 0, 0, 0.06) !important",
                                    }}
                                  >
                                    {row.total_search_volume}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      padding: "10px !important",
                                      borderBottom:
                                        "1px solid rgba(0, 0, 0, 0.06) !important",
                                    }}
                                  >
                                    {row.cluster}
                                    {/* <Box
                                      display="flex"
                                      alignItems="center"
                                      onClick={() => toggleExpand(index)}
                                    >
                                      <Box>
                                        {isClusterExpand ? (
                                          <>
                                            <Typography variant="body2">
                                              {row?.clusters.length}
                                            </Typography>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 2,
                                                mt: 2,
                                              }}
                                            >
                                              {row?.clusters.map(
                                                (cluster: any, i: number) => (
                                                  <Typography
                                                    key={i}
                                                    variant="body2"
                                                  >
                                                    {cluster}
                                                  </Typography>
                                                )
                                              )}
                                            </Box>
                                          </>
                                        ) : (
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              color:
                                                "var(--text-secondary, rgba(0, 0, 0, 0.60))",
                                              fontFeatureSettings:
                                                "'liga' off, 'clig' off",
                                            }}
                                          >
                                            {row?.clusters.length}
                                          </Typography>
                                        )}
                                      </Box>
                                    </Box> */}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      padding: "10px !important",
                                      borderBottom:
                                        "1px solid rgba(0, 0, 0, 0.06) !important",
                                    }}
                                  >
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Box>
                                        {isExpanded ? (
                                          <>
                                            <Typography variant="body2">
                                              {row?.keywords.length}
                                            </Typography>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 2,
                                                mt: 2,
                                              }}
                                            >
                                              {row?.keywords.map(
                                                (keyword: any, i: number) => (
                                                  <Typography
                                                    key={i}
                                                    variant="body2"
                                                  >
                                                    {keyword}
                                                  </Typography>
                                                )
                                              )}
                                            </Box>
                                          </>
                                        ) : (
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              color:
                                                "var(--text-secondary, rgba(0, 0, 0, 0.60))",
                                              fontFeatureSettings:
                                                "'liga' off, 'clig' off",
                                            }}
                                          >
                                            {row?.keywords.length}
                                          </Typography>
                                        )}
                                      </Box>

                                      <IconButton
                                        onClick={() => toggleExpand(index)}
                                      >
                                        {isExpanded ? (
                                          <ExpandLess />
                                        ) : (
                                          <ExpandMore />
                                        )}
                                      </IconButton>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[100, 200, 300, 400, 500, 1000]}
                    component="div"
                    count={paginatedData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BubbleClusterChart bubbleChartData={clustersData} />
                </Box>
              )}
            </Card>
          )}
        </Loader>
      </Box>
    </Box>
  );
};

export default Startegy;
